import React, { useEffect, useState } from 'react';
import Accordion from './Components/EcomAccordion';
import { Box, Paper, Typography, Button } from '@mui/material'; 
import styled from 'styled-components';
import AppNoDataLoader from '../../../../../AppComponents/AppNoDataLoader';
import { useAppDispatch, useAppSelector } from '../../../../../Store'
import { useParams } from 'react-router-dom';
import { ContactsActions } from '../../../../../Store/Slices/Contacts/contacts.action';
import { ecommerceOrdersCount, ecommerceOrdersData, ecommerceOrdersDataPagination } from '../../../../../Store/Slices/Contacts/contacts.selector';
import { resetEcommerceOrderList } from '../../../../../Store/Slices/Contacts/contacts.slice';

const OrderListContainer = styled(Box)`
  padding: 16px;
  height: 100%;
  min-height: 60vh;
`;

const LoadMoreButtonContainer = styled(Box)`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

const OrderList: React.FC = () => {
  const [expandedOrderId, setExpandedOrderId] = useState<number | false>(false);
  const { contact_id, store_type } = useParams<{ contact_id: string, store_type: string }>();
  const orders: any = useAppSelector(ecommerceOrdersData);
  const orderCount: any = useAppSelector(ecommerceOrdersCount);
  const { has_more, limit, offset }: any = useAppSelector(ecommerceOrdersDataPagination);

  const dispatch = useAppDispatch();

  // Handles accordion state
  const handleAccordionChange = (orderId: number) => {
    setExpandedOrderId(expandedOrderId === orderId ? false : orderId);
  };

  // Fetch initial orders when component mounts
  useEffect(() => {
    if (contact_id && store_type) {
      dispatch(ContactsActions.fetchEcommerceOrderList({ contact_id, store_type }));
    }

    return () => {
      dispatch(resetEcommerceOrderList());
    };
  }, [contact_id,store_type,dispatch]);

  // Load more orders function
  const handleLoadMoreOrders = () => {
    if (contact_id && store_type && has_more) {
      dispatch(
        ContactsActions.fetchEcommerceOrderList({
          contact_id,
          store_type,
          offset: offset + limit, // Update offset to load more
          limit, // Keep the same limit
        })
      );
    }
  };

  return (
    <OrderListContainer>
      <Typography variant="h6" gutterBottom>
        Orders({orderCount})
      </Typography>
      {orders.length === 0 ? (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            padding: '4rem 2rem 2rem 2rem',
            boxShadow: 'none important',
            backgroundColor: 'white',
          }}
        >
          <Paper
            sx={{
              width: '40%',
              mb: 2,
              boxShadow: 'none !important',
              backgroundColor: 'transparent',
            }}
          >
            <AppNoDataLoader />
          </Paper>
        </Box>
      ) : (
        <>
          {orders.map((order: any) => (
            <Accordion
              key={order.order_id}
              expanded={expandedOrderId === order.order_id}
              onChange={() => handleAccordionChange(order.order_id)}
              order={order}
            />
          ))}

          {/* Load More Button */}
          {has_more && (
            <LoadMoreButtonContainer>
              <Button variant="contained" onClick={handleLoadMoreOrders}>
                Load More Orders
              </Button>
            </LoadMoreButtonContainer>
          )}
        </>
      )}
    </OrderListContainer>
  );
};

export default OrderList;
